<template>
  <div>
    <slot
      :controllers="{ clickSubscribeVertical, clickSubscribeMiniPlans, clickSubscribeHorizontal }"
    ></slot>
  </div>
</template>
<script>
export default {
  methods: {
    clickSubscribePlan(plan) {
      this.$cookies.set('vx.plan', plan);
      this.$store.dispatch('plans/OPEN_PLAN', plan);
      this.beginCheckoutEvent(plan);
      this.$router.push(this.$urlBuilder('purchase'));
    },
    beginCheckoutEvent(plan) {
      this.$dataLayerPush('begin_checkout', {
        beginCheckout: plan
      });
    },
    topSubscribeEvent(id) {
      this.$dataLayerPush('click_top_subscribe', {
        subscribe: {
          idPlan: id
        }
      });
    },
    lifetimeSubscribeEvent(id) {
      this.$dataLayerPush('click_lifetime_subscribe', {
        subscribe: {
          idPlan: id
        }
      });
    },
    miniPlansSubscribeEvent(id) {
      this.$dataLayerPush('mini_plans_slice_subscribe', {
        subscribe: {
          idPlan: id
        }
      });
    },
    clickSubscribeVertical(plan) {
      const { id } = plan;
      this.topSubscribeEvent(id);
      this.clickSubscribePlan(plan);
    },
    clickSubscribeHorizontal(plan) {
      const { id } = plan;
      this.lifetimeSubscribeEvent(id);
      this.clickSubscribePlan(plan);
    },
    clickSubscribeMiniPlans(plan) {
      const { id } = plan;
      this.clickSubscribePlan(plan);
      this.miniPlansSubscribeEvent(id);
    }
  }
};
</script>
